import { defineComponent as _defineComponent } from 'vue'
import { useOpenLinksInNewTab } from '@/ui/concerns/useOpenLinksInNewTab';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'RichText',
  props: {
    content: {
      type: String,
      required: true,
      default: '',
    },
  },
  setup(__props) {

  

  const containerRef = useOpenLinksInNewTab();

return { __sfc: true,containerRef }
}

})